import {Query, gql} from 'apollo-angular';
import { Injectable } from '@angular/core';
import { IPage } from '@collections/common/interfaces';
import { productFragment } from './fragments/product.fragment';
import { IProduct } from '@collections/products/interfaces';
import { pageInfoFragment } from '@shared/services/common/fragments/page-info.fragment';

export interface CompanyProductsResponse {
  productsByCompany: IPage<IProduct>;
}

@Injectable()
export class CompanyProductsGQL extends Query<CompanyProductsResponse> {
  document = gql`
  query getProductsByCompany($companyId:ObjectId!, $lang: String!, $first: Int, $after: String, $category: String, $adminMode: Boolean) {
    productsByCompany(companyId:$companyId, lang: $lang, first: $first, after: $after, category: $category, adminMode: $adminMode) {
      totalCount
      edges {
        cursor
        node {
            ...product
          }
      }
      pageInfo {
        ...pageInfo
      }
    }
  }
  ${productFragment},
  ${pageInfoFragment}
  `;
}
